import type { TestContext } from 'yup';
import { queryClient } from '../../../lib/react-query';
import { useMeOptions } from '../../users';

export async function allowedProjectCheck(this: TestContext, value: number) {
  try {
    const data = await queryClient.ensureQueryData(useMeOptions);

    if (!data.role) {
      throw new Error('Invalid user role');
    }

    if (data.role === 'admin' || data.role === 'supervisor') return true;

    if (data.role === 'user' && data.projects.map((p) => p.id).includes(value)) {
      return true;
    }

    throw new Error('Please select the project you have access to');
  } catch (e) {
    // @ts-expect-error error type correction
    return this.createError({ message: String(e.message) });
  }
}
